<template>
    <div>
        <v-card elevation="0">
            <v-card-title>
                <v-row>
                    <v-col cols="12" sm="6">
                        <span class="subtitle-typology">{{$t('backoffice.modules-management.planning.datatable-typology-services.subtitle')}}</span>
                    </v-col>
                    <v-col cols="12" sm="6" class="text-end">
                        <div class="circle" @click="onAddNewTypologyRow">
                            <img src="/images/_SVGs/bo/adicionar.svg"  onload="SVGInject(this)"  width="30" height="30"/>
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-data-table ref="datatableTypology" :headers="headers" :items="typologyList">
                <template v-slot:[`item.description`]="{ item }">
                    <v-text-field
                        v-model="dataTypologyEdit.description"
                        hide-details
                        :rules="formRules.defaultRules"
                        :placeholder="$t('backoffice.modules-management.planning.datatable-typology-services.typology-name')"
                        v-if="item.isEdit"
                    ></v-text-field>

                    <span v-else>
                        {{item.description}}
                    </span>
                </template>

                <template v-slot:[`item.isActive`]="{ item }">
                        <v-switch
                            class="switch-user"
                            v-model="dataTypologyEdit.isActive"
                            :class="dataTypologyEdit.isActive ? 'custom-red' : ''"
                            color="green"
                            small
                            :label="dataTypologyEdit.isActive ? $t('backoffice.general.active-status') : $t('backoffice.general.inactive-status')"
                            v-if="item.isEdit"
                        ></v-switch>
                        <v-chip
                            v-else
                            :color="getColor(item.isActive)"
                            pill
                            dark
                            small
                            class="status-column"
                        >
                            {{ translateFlag(item.isActive) }}
                        </v-chip>
                </template>

                <template v-slot:[`item.workTime`]="{ item }">
                    <v-dialog
                            ref="dialog"
                            v-model="allowableWasteOfTimeModal"
                            :return-value.sync="dataTypologyEdit.workTime"
                            persistent
                            width="290px"
                            v-if="item.isEdit"
                        >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dataTypologyEdit.workTime"
                                append-icon="mdi-clock-time-four-outline"
                                readonly
                                :rules="formRules.defaultRules"
                                hide-details
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-time-picker
                            v-if="allowableWasteOfTimeModal"
                            v-model="dataTypologyEdit.workTime"
                            full-width
                            format="24hr"
                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="allowableWasteOfTimeModal = false"
                            >
                                {{$t('backoffice.actions.cancel')}}
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.dialog.save(dataTypologyEdit.workTime)"
                            >
                                {{$t('backoffice.actions.ok')}}
                            </v-btn>
                        </v-time-picker>
                    </v-dialog>

                    <span v-else>
                        {{ getTimeHHmm(item.workTime)}}
                    </span>
                </template>

                <template v-slot:[`item.hasDefaultQuotation`]="{ item }">
                        <v-switch
                            class="switch-user"
                            v-model="dataTypologyEdit.hasDefaultQuotation"
                            :class="dataTypologyEdit.hasDefaultQuotation ? 'custom-red' : ''"
                            color="green"
                            :label="dataTypologyEdit.hasDefaultQuotation ? $t('backoffice.general.active-status') : $t('backoffice.general.inactive-status')"
                            v-if="item.isEdit"
                        ></v-switch>
                        <span v-else>
                            <div v-if="item.hasDefaultQuotation == true">
                              <img src="/images/_SVGs/bo/check.svg"  onload="SVGInject(this)" width="15" height="15" fill="green" />
                            </div>
                        </span>
                </template>

                <template v-slot:[`item.action`]="{ item }">
                    <div class="div-actions">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span style="cursor: pointer;" v-bind="attrs" v-on="on" @click="onEditRow(item.planningOperationTypeID)" v-show="item.isEdit == false">
                                    <img src="/images/_SVGs/bo/edit_pencil.svg" onload="SVGInject(this)" width="20" height="20"/>
                                </span>
                            </template>
                            <span>{{$t('backoffice.modules-management.planning.datatable-typology-services.edit-typology')}}</span>
                        </v-tooltip>
                        <span  v-show="item.isEdit == false">
                        <v-tooltip bottom v-if="!item.isAssociatePlanning">
                            <template v-slot:activator="{ on, attrs }">
                                <span style="cursor: pointer;" class="mr-2 p-0" @click="onDeleteClicked(item)" v-bind="attrs" v-on="on">
                                    <img src="/images/_SVGs/bo/remove.svg" alt="remover" onload="SVGInject(this)" width="30" height="30" class="circle"/>
                                </span>
                            </template>
                            <span>{{$t('backoffice.modules-management.planning.datatable-typology-services.remove-typology')}}</span>
                        </v-tooltip>
                            <template v-else>
                                <span style="cursor: no-drop !important;" class="mr-2 p-0" @click="modalAlert.show = true">
                                    <img src="/images/_SVGs/bo/remove-block.svg" alt="remover" onload="SVGInject(this)" width="30" height="30" class="circle nodrop"/>
                                </span>
                            </template>
                        </span>
                        <!-- -->

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span style="cursor: pointer; widht:20px; margin-right: 5px;" :style="dataTypologyEdit.planningOperationTypeID > 0 ? '' : 'opacity: 0.5;'" @click="onSaveTypologyRow" v-show="item.isEdit" v-bind="attrs" v-on="on">
                                    <img src="/images/_SVGs/bo/check.svg"  onload="SVGInject(this)" width="15" height="15" fill="green"/>
                                </span>
                            </template>
                            <span>{{$t('backoffice.actions.record')}} </span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span style="cursor: pointer; widht:20px;" @click="onCancelTypologyRow(item.planningOperationTypeID)" v-show="item.isEdit" v-bind="attrs" v-on="on">
                                    <img src="/images/_SVGs/environmental/fechar.svg"  onload="SVGInject(this)" width="25" height="25" fill="red"/>
                                </span>
                            </template>
                            <span>{{$t('backoffice.actions.cancel')}} </span>
                        </v-tooltip>

                    </div>
                </template>
            </v-data-table>
        </v-card>

        <base-modal v-model="modalInfo.show" :title="$t('backoffice.general.warning')" modal-width="460px" modalAlign="align__flex--center" iconColor="warning" iconName="mdi-alert-outline">
            <template v-slot:modal-body>
                {{$t('backoffice.modules-management.planning.datatable-typology-services.modal-info-msg')}}
            </template>

            <template v-slot:modal-actions>
                <div>
                    <v-btn style="text-transform: capitalize" class="primary-button mr-2" text @click="modalInfo.show = false; modalInfo.id = 0;">
                        {{$t('backoffice.actions.no')}}
                    </v-btn>

                    <v-btn style="text-transform: capitalize" class="danger-button" text @click="onRemoveRow(modalInfo.id)">
                        {{$t('backoffice.actions.yes')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal v-model="modalRequest.show" :title="modalRequest.title" modal-width="312px" :iconColor="modalRequest.iconColor" :iconName="modalRequest.iconName">
            <template v-slot:modal-body style="text-align: center">
                {{ modalRequest.message }}
            </template>

            <template v-slot:modal-actions class="align__flex--center">
                <div></div>
                <div>
                    <v-btn color="" text class="primary-button" @click="modalRequest.show = false" style="text-transform: capitalize">
                        {{$t('backoffice.actions.ok')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>

import {
    ModulesServicesCreatePlanningOperation,
    ModulesServicesUpdatePlanningOperation,
    ModulesServicesDeletePlanningOperation,
    ModulesServicesGetPlanningOperation
} from '@services/backoffice/Modules/ModulesServices'

import { required } from "@src/utils/validations.js";
import dayjs from 'dayjs'
import BaseModal from "@components/shared/widgets/BaseModal.vue";

export default {
    components: {BaseModal},
    props: {
        entityID: Number
    },
    data () {
        return {
            allowableWasteOfTimeModal: false,
            formRules: { defaultRules: [required]},
            headers: [
                { text: this.$t('backoffice.modules-management.planning.datatable-typology-services.table-headers.typology'), value: 'description' },
                { text: this.$t('backoffice.modules-management.planning.datatable-typology-services.table-headers.status'), value: 'isActive', align: "center" },
                { text: this.$t('backoffice.modules-management.planning.datatable-typology-services.table-headers.service-time'), value: 'workTime', align: "center"},
                { text: this.$t('backoffice.modules-management.planning.datatable-typology-services.table-headers.preset-budget'), value: 'hasDefaultQuotation', align: "center" },
                { text: '', value: 'action', sortable: false }],
            dataTypologyEdit: [],
            modalInfo:{ show: false, id: 0 },
            typologyList: [
                // { "planningOperationTypeID": 1, "description": "Serviço XYZ", "isActive": true, isEdit: false, isCreate: false },
                // { "planningOperationTypeID": 2, "description": "Serviço QWERTY", "isActive": true, isEdit: false, isCreate: false },
            ],
            modalRequest: { show: false, message: '', title: '', iconColor: '', iconName: '' },
        }
    },

    methods:{
        onDeleteClicked(item){
            this.modalInfo.show = true;
            this.modalInfo.id = item.planningOperationTypeID;
        },
        getTimeHHmm(time){
            return dayjs(time, 'HH:mm').format('HH:mm')
        },
        handleGetPlanningOperations() {
            this.$store.commit('loadings/setStateLoadingTemplate', true);
            let body = {
                entityId: this.entityID
            }
            return ModulesServicesGetPlanningOperation(body)
                .then(response => {

                    if(response.data.result && response.data.result.length > 0) {
                        let res = response.data.result;
                        res.forEach(element => {
                            Object.assign(element, {
                                isEdit: false,
                                isCreate: false
                            })
                        });

                        this.typologyList = res;
                    }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error ModulesServicesGetPlanningOperation', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
        },

        onAddNewTypologyRow() {
            if(this.dataTypologyEdit.length == 0){
                const dataNew = {
                    planningOperationTypeID: 0,
                    description:'',
                    isActive: true,
                    isEdit: true,
                    isCreate: true,
                    hasDefaultQuotation: false,
                    workTime: '00:00'
                }

                this.dataTypologyEdit = dataNew;
                this.typologyList.unshift(dataNew);
            }
        },

        onEditRow(rowId) {
            const items = this.typologyList;
            if(this.dataTypologyEdit.length == 0){
                for (let key in items) {
                    if (items[key].planningOperationTypeID == rowId) {
                        Object.assign(items[key], {
                            isEdit: true,
                        });

                        this.dataTypologyEdit = _.cloneDeep(items[key])

                    }else{
                        Object.assign(items[key], {
                            isEdit: false
                        });
                    }
                }
            }
        },

        onSaveTypologyRow() {
            if(this.dataTypologyEdit.isCreate) {
                this.onCreateNewTypology();
            } else {
                this.onUpdateTypology();
            }
        },

        onCreateNewTypology() {
            this.$store.commit('loadings/setStateLoadingTemplate', true);
            const items = _.cloneDeep(this.typologyList);
            const editRow = _.cloneDeep(this.dataTypologyEdit);

            let body = {
                "entityId": this.entityID,
                "description": editRow.description,
                "isActive": editRow.isActive ? editRow.isActive : false,
                "hasDefaultQuotation": editRow.hasDefaultQuotation ? editRow.hasDefaultQuotation : false,
                "workTime": editRow.workTime
            }

            ModulesServicesCreatePlanningOperation(body)
                .then((response) => {
                    for(let index in items) {
                        if(items[index].planningOperationTypeID == editRow.planningOperationTypeID) {
                            Object.assign(items[index], {
                                description: editRow.description,
                                isEdit: false,
                                isCreate: false,
                                planningOperationTypeID: response.data.result.id,
                                isActive: editRow.isActive,
                                hasDefaultQuotation: editRow.hasDefaultQuotation,
                                isAssociatePlanning: false,
                                workTime: editRow.workTime,
                            });
                        }

                        this.typologyList = _.cloneDeep(items);
                    }

                    this.dataTypologyEdit = [];
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error ModulesServicesCreatePlanningOperation', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
        },

        onUpdateTypology() {
            this.$store.commit('loadings/setStateLoadingTemplate', true);

            const items = _.cloneDeep(this.typologyList);
            const editRow = _.cloneDeep(this.dataTypologyEdit);

            let body = {
                "description": editRow.description,
                "isActive": editRow.isActive ? editRow.isActive : false,
                "hasDefaultQuotation": editRow.hasDefaultQuotation ? editRow.hasDefaultQuotation : false,
                "workTime": editRow.workTime
            }

            ModulesServicesUpdatePlanningOperation(editRow.planningOperationTypeID, body)
                .then((response) => {
                        for(let index in items) {
                            if(items[index].planningOperationTypeID == editRow.planningOperationTypeID) {
                                Object.assign(items[index], {
                                    description: editRow.description,
                                    isEdit: false,
                                    isCreate: false,
                                    hasDefaultQuotation: editRow.hasDefaultQuotation,
                                    isActive: editRow.isActive,
                                    workTime: editRow.workTime,
                                });
                            }

                            this.typologyList = _.cloneDeep(items);
                        }

                        this.dataTypologyEdit = [];
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error ModulesServicesUpdatePlanningOperation', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
        },

        onCancelTypologyRow(rowId) {
            let copyList = _.cloneDeep(this.typologyList);

            if(rowId === 0){
                copyList.splice(rowId, 1);
            } else {
                for(let key in copyList) {
                    Object.assign(copyList[key], {
                        isEdit: false
                    });
                }
            }
            this.dataTypologyEdit = [];
            this.typologyList = _.cloneDeep(copyList);
        },

        onRemoveRow(rowId) {
            this.$store.commit('loadings/setStateLoadingTemplate', true);

            ModulesServicesDeletePlanningOperation(rowId)
                .then(response => {

                    let copyList = _.cloneDeep(this.typologyList);
                    const index = this.typologyList.findIndex(el => el.planningOperationTypeID == rowId);

                    if(index > -1){
                        copyList.splice(index, 1)
                    };

                    this.typologyList = _.cloneDeep(copyList);
                    this.modalInfo.show = false;
                    this.modalInfo.id = 0;

                })
                .catch(error => {
                    console.log(error);
                    this.modalInfo.show = false;
                    this.modalInfo.id = 0;
                    this.modalRequest.title = this.$t('backoffice.general.warning')
                    this.modalRequest.message = this.$t('backoffice.modules-management.planning.datatable-typology-services.modal-request-msg');
                    this.modalRequest.iconColor = "warning";
                    this.modalRequest.iconName = "mdi-alert-outline";
                    this.modalRequest.show = true;
                    if(error?.response?.status) {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    }
                    throw new Error('error ModulesServicesDeletePlanningOperation', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
        },

        getColor(status) {
            if (status) return "green";
            else if (!status) return "red";
            else return "orange";
        },

        translateFlag(status) {
            if (status) return this.$t('backoffice.general.active-status')
            else return this.$t('backoffice.general.inactive-status')
        }
    },

    mounted() {
        this.handleGetPlanningOperations();
    }
}
</script>

<style lang="scss" scoped>

.subtitle-typology {
    margin-top: -40px;
    z-index: 99;
    margin-left: 2px;
    font-size: 20px;
    font-weight: bold;
    color: #4B4849;
}

.circle{
    width: 40px !important;
    height: 40px !important;
    padding: 0 5px;
    background-color: var(--v-primary-base) !important;
    ::v-deep svg{
        path{
            fill: #fff;
        }
    }
}
::v-deep table{
    thead{
        tr{
            th{
                background-color: #F2F2F2 !important;
                color:#9E9D9D !important;
                font-weight: 500;

                border: 0;
            }
        }
    }
    tbody{
        tr{
            td{
                font-size: 12px;
                border: 0;
            }
        }
    }

}
    .search{
        .v-input__control{
            .v-input__slot{
                margin-bottom: 0px !important;
                &::before{
                    border: 0 !important;
                }
                label{
                    font-size: 12px;
                    color: #9E9D9D;
                }
            }
        }
        .v-text-field__details{
            min-height: 0px;
            display: none;
        }
    }
    .div-actions{
        text-align: end;

        .circle {
            background-color: #e6e5e5 !important;
            width: 20px !important;
            height: 20px !important;
            border-radius: 50% !important;
            display: -webkit-inline-box !important;
            padding: 0 !important;
        }
    }
</style>
